// todo: hoc dnd 교체 필요
import React from 'react';

const HistoryView = () => {
  return <div></div>;
};

export default HistoryView;

// import React, { useCallback } from 'react';
// import InputTitleView from './InputTitleView';
// import { useIntl } from 'react-intl';
// import IntlMessages from 'Util/IntlMessages';
// import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
// import { TextField } from '@mui/material';
// import icDate from 'Assets/img/recruitment/ic_date.png';
// import icDate2 from 'Assets/img/recruitment/ic_date@2x.png';
// import icDate3 from 'Assets/img/recruitment/ic_date@3x.png';
// import icSort from 'Assets/img/recruitment/ic_sort.png';
// import icSort2 from 'Assets/img/recruitment/ic_sort@2x.png';
// import icSort3 from 'Assets/img/recruitment/ic_sort@3x.png';
// import icDelete from 'Assets/img/recruitment/ic_list_delete.png';
// import icDelete2 from 'Assets/img/recruitment/ic_list_delete@2x.png';
// import icDelete3 from 'Assets/img/recruitment/ic_list_delete@3x.png';
// import { arrayMove, getImageSet } from 'Util/DataUtils';
// import { sortableContainer, sortableElement, SortableHandle } from 'react-sortable-hoc';
// import { useSelector } from 'react-redux';
// import { getDotFormatDateFns } from 'Util/DateUtils';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { ko, vi } from 'date-fns/locale';

// const customFieldStyle = {
//   '& .MuiOutlinedInput-root': {
//     fieldset: {
//       border: '1px solid #DDD',
//       height: '44px',
//       width: '100%',
//     },
//     '&:hover fieldset': {
//       borderColor: '#DDD',
//     },
//     '&.Mui-focused fieldset': {
//       border: '1px solid #DDD',
//     },
//     '&.Mui-error fieldset': {
//       border: '1px solid #DDD',
//     },
//   },
// };
// const dateImgs = getImageSet([icDate, icDate2, icDate3]);
// const sortImgs = getImageSet([icSort, icSort2, icSort3]);
// const deleteSet = getImageSet([icDelete, icDelete2, icDelete3]);

// const DragHandler = SortableHandle(() => (
//   <div className="history-item-sort">
//     <img {...sortImgs} alt="sort" />
//   </div>
// ));

// const SortableItem = sortableElement(({ item, idx, onChangeInput, onClickDeleteItem, formatMessage, locale }) => (
//   <div key={`item_${idx}`} className="history-item">
//     <div className="history-item-contents-wrapper">
//       <div className="history-item-contents">
//         <div className="history-item-contents-title">
//           <IntlMessages id="recruitment.companyHistories.content" />
//         </div>
//         <div className="history-text-input">
//           <input
//             type="text"
//             name="content"
//             placeholder={formatMessage({ id: 'recruitment.companyHistories.content.placeholder' })}
//             value={item.content}
//             onChange={({ target }) => onChangeInput({ index: idx, name: target.name, value: target.value })}
//           />
//         </div>
//       </div>
//       <div className="history-item-contents">
//         <div className="history-item-contents-title">
//           <IntlMessages id="recruitment.companyHistories.date" />
//         </div>
//         <div className="history-date-input">
//           <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale === 'vi' ? vi : ko}>
//             <DatePicker
//               inputFormat={getDotFormatDateFns(locale)}
//               className="datePicker"
//               id="date"
//               value={item.date}
//               onChange={e => onChangeInput({ index: idx, name: 'date', value: e })}
//               InputAdornmentProps={{
//                 position: 'start',
//               }}
//               components={{
//                 OpenPickerIcon: () => <img {...dateImgs} alt="date" />,
//               }}
//               renderInput={params => (
//                 <TextField
//                   {...params}
//                   sx={customFieldStyle}
//                   placeholder={formatMessage({ id: 'recruitment.companyHistories.date.placeholder' })}
//                   inputProps={{
//                     ...params.inputProps,
//                     placeholder: formatMessage({ id: 'recruitment.companyHistories.date.placeholder' }),
//                   }}
//                 />
//               )}
//             />
//           </LocalizationProvider>
//         </div>
//       </div>
//       <div className="history-item-contents">
//         <div className="history-item-contents-title">
//           <IntlMessages id="recruitment.companyHistories.memo" />
//         </div>
//         <div className="history-text-input">
//           <input
//             type="text"
//             name="memo"
//             placeholder={formatMessage({ id: 'recruitment.companyHistories.memo.placeholder' })}
//             value={item.memo}
//             onChange={({ target }) => onChangeInput({ index: idx, name: target.name, value: target.value })}
//           />
//         </div>
//       </div>
//     </div>
//     <DragHandler />
//     <div className="history-item-delete" onClick={() => onClickDeleteItem(idx)}>
//       <img {...deleteSet} alt="delete" />
//     </div>
//   </div>
// ));
// const SortableContainer = sortableContainer(({ children }) => <div className="history-wrapper">{children}</div>);

// const HistoryView = ({ value, onChange }) => {
//   const { formatMessage } = useIntl();
//   const { locale } = useSelector(state => state.settings.locale);

//   const onClickAddHistory = () => {
//     onChange({
//       name: 'companyHistories',
//       value: [
//         {
//           content: '',
//           date: null,
//           memo: '',
//         },
//         ...value,
//       ],
//     });
//   };

//   const onClickDeleteItem = index => {
//     onChange({
//       name: 'companyHistories',
//       value: value.filter((_, i) => i !== index),
//     });
//   };

//   const onChangeInput = ({ index, name, value: nowValue }) => {
//     onChange({
//       name: 'companyHistories',
//       value: value.map((x, i) => {
//         if (index !== i) return x;
//         return {
//           ...x,
//           [name]: nowValue,
//         };
//       }),
//     });
//   };

//   const onSortEnd = useCallback(
//     ({ oldIndex, newIndex }) => {
//       const items = arrayMove(value, oldIndex, newIndex);
//       onChange({
//         name: 'companyHistories',
//         value: items,
//       });
//     },
//     [value]
//   );

//   return (
//     <div className="recruitment-history-view">
//       <InputTitleView title={formatMessage({ id: 'recruitment.companyHistories' })} required={false} subTitle="" />
//       <div className="recruitment-history-wrapper">
//         <div className="recruitment-history-button" onClick={onClickAddHistory}>
//           <IntlMessages id="recruitment.companyHistories.button" />
//         </div>
//         {value.length > 0 && (
//           <div className="recruitment-list-guide">
//             <IntlMessages id="recruitment.list.guide" />
//           </div>
//         )}
//         <SortableContainer onSortEnd={onSortEnd} axis="y" distance={1} helperClass="history-drag-item" useDragHandle>
//           {value.map((item, idx) => (
//             <SortableItem key={idx} index={idx} idx={idx} item={item} onChangeInput={onChangeInput} onClickDeleteItem={onClickDeleteItem} formatMessage={formatMessage} locale={locale} />
//           ))}
//         </SortableContainer>
//       </div>
//     </div>
//   );
// };

// export default HistoryView;
